/* Atelier policy pages: on mobile the policy links are a swipe row of chips. When the current page's chip is cut off,
   scroll the row just far enough (to a chip's snap point) to show it, keeping as many earlier chips in view as possible. */
if (!customElements.get('atelier-policy-nav')) {
  customElements.define(
    'atelier-policy-nav',
    class AtelierPolicyNav extends HTMLElement {
      connectedCallback() {
        this.touched = false;
        this.onTouch = () => {
          this.touched = true;
        };
        ['pointerdown', 'wheel', 'keydown'].forEach((type) => this.addEventListener(type, this.onTouch, { passive: true }));
        requestAnimationFrame(() => this.reveal());
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.reveal());
      }

      disconnectedCallback() {
        ['pointerdown', 'wheel', 'keydown'].forEach((type) => this.removeEventListener(type, this.onTouch));
      }

      reveal() {
        if (this.touched) return;
        const row = this.querySelector('.at-policy__links');
        const current = row && row.querySelector('[aria-current="page"]');
        if (!current || row.scrollWidth <= row.clientWidth + 1) return;

        const style = getComputedStyle(row);
        const padLeft = parseFloat(style.paddingLeft) || 0;
        const padRight = parseFloat(style.paddingRight) || 0;
        const origin = row.getBoundingClientRect().left - row.scrollLeft;
        const startOf = (el) => el.getBoundingClientRect().left - origin;
        const view = row.clientWidth;
        const max = row.scrollWidth - view;
        const currentStart = startOf(current);
        const currentEnd = currentStart + current.getBoundingClientRect().width;

        const fullyVisible =
          currentStart >= row.scrollLeft + padLeft - 1 && currentEnd <= row.scrollLeft + view - padRight + 1;
        if (fullyVisible) return;

        let target = currentStart - padLeft;
        for (const chip of row.children) {
          const left = startOf(chip) - padLeft;
          if (left >= target) break;
          if (currentEnd - left <= view - padLeft - padRight || left >= max) {
            target = left;
            break;
          }
        }
        row.scrollLeft = Math.max(0, Math.min(max, target));
      }
    }
  );
}
